/**
 * brandMark — the ONE source of truth for picking the in-app CellCog mark.
 *
 * THE INVARIANT: ink must contrast with the background it lands on.
 *   dark background  -> light-coloured (white) mark
 *   light background -> dark-coloured (black) mark
 *
 * ⚠️ NAMING TRAP — do NOT infer ink colour from a filename in this repo. Three
 * contradictory conventions coexist (all measured, not guessed):
 *
 *   logo192-light.png            transparent BLACK mark. "-light" = "for LIGHT
 *                                mode", NOT "light-coloured". Ink luminance 28.
 *   logo192-dark-transparent.png transparent WHITE mark, i.e. the dark-MODE
 *                                mark. Ink luminance 243.
 *   logo192.png / logo512.png    NOT marks — opaque app-icon TILES (white C on
 *                                #141414). Never use these inline on a themed
 *                                surface: the tile paints its own dark square
 *                                over the surface behind it. Favicons/manifest/
 *                                PWA only.
 *
 * Both files are generated from marketing/assets/brand/master/cellcog-mark.svg by
 * marketing/assets/brand/generate_brand_assets.py — see that dir's README before
 * adding or regenerating any brand asset.
 */

/** Transparent WHITE mark — for dark backgrounds. */
export const BRAND_MARK_ON_DARK = '/logo192-dark-transparent.png';

/** Transparent BLACK mark — for light backgrounds. */
export const BRAND_MARK_ON_LIGHT = '/logo192-light.png';

/**
 * Correct mark for the current theme.
 *
 * Note: on logged-out surfaces isDarkMode is always true (ThemeContext pins it
 * for visitors, and MarketingLayout forces data-theme="dark"), so auth pages
 * resolve to the white mark by design.
 *
 * @param {boolean} isDarkMode from useTheme()
 * @returns {string} public-root path to the mark
 */
export const brandMarkSrc = (isDarkMode) =>
  isDarkMode ? BRAND_MARK_ON_DARK : BRAND_MARK_ON_LIGHT;
